import {
  OPEN_TAB_EVENT, ON_TAB_CLOSE, ON_TAB_SELECTION, ON_TAB_RENAME, ON_TAB_MOVE,
} from '../actions/tab';

const tab = (state = {}, event = {}) => {
  switch (event.type) {
    case OPEN_TAB_EVENT:
      return openTabAction(state, event);
    case ON_TAB_CLOSE:
      return onTabClose(state, event);
    case ON_TAB_SELECTION:
      return onTabSelection(state, event);
    case ON_TAB_RENAME:
      return onTabRename(state, event);
    case ON_TAB_MOVE:
      return onTabMove(state, event);
    default:
      return state;
  }
};

const onTabMove = (state, event) => {
  const { tabs = [], } = state;
  const { draggedIndex, targetIndex, } = event;
  const updatedTabs = [ ...tabs, ];
  const [ movedTab, ] = updatedTabs.splice(draggedIndex, 1);
  updatedTabs.splice(targetIndex, 0, movedTab);

  return {
    ...state,
    tabs: updatedTabs,
  };
};

export const openTabAction = (state, event) => {
  const { tabs = [], } = state;

  if (event.selectedTab) {
    const DuplicateTabs = (tabs.filter(value => (event.selectedTab.key.replace(/[0-9]/g, '')).replace(/\s/g, '') === (value.key.replace(/[0-9]/g, '')).replace(/\s/g, '')));
    const numberOfTabs = DuplicateTabs.length;
    const existingTab = tabs.find(value => event.selectedTab.key === value.key);
    if (existingTab) {
      const newTab = { ...existingTab, };
      let tabNumber = 1;
      let addedString = (existingTab.key + ((numberOfTabs + 1).toString()).padStart(3, ' '));
      const existing = function existing() {
        return DuplicateTabs.find(tabItem => tabItem.tabName === addedString);
      };
      while (existing()) {
        tabNumber += 1;
        addedString = (existingTab.key + ((numberOfTabs + tabNumber).toString()).padStart(3, ' '));
        existing();
      }
      newTab.tabName = addedString;
      newTab.key = addedString;
      tabs.push(newTab);
      return {
        selectedTab: newTab,
        tabs,
      };
    }
    tabs.push(event.selectedTab);
    return {
      selectedTab: event.selectedTab,
      tabs,
    };
  }

  return {
    ...state,
  };
};

const onTabSelection = (state, event) => {
  const { tabs = [], } = state;
  let newTab = tabs.find(tabItem => tabItem.key === event.selectedTab.key);

  if (!newTab && tabs.length > 0) {
    [ newTab, ] = tabs;
  }

  return {
    selectedTab: newTab,
    tabs,
  };
};

const onTabClose = (state, event) => {
  const { tabs = [], } = state;
  const tabsToKeep = tabs.filter(item => item.key !== event.closingTab.key);
  const newTab = tabsToKeep.length > 0 ? tabsToKeep[0] : undefined;
  return {
    tabs: tabsToKeep,
    selectedTab: newTab,
  };
};

const onTabRename = (state, event) => {
  const { tabs = [], } = state;
   
  let enterName = prompt('Please enter a unique tab name');
  if (enterName === null) {
    return {
      ...state,
    };
  }
  const Dupe = function Dupe() {
    return tabs.find(item => item.tabName === enterName);
  };
  while ((Dupe()) || enterName === null) {
     
    enterName = prompt('ERROR: Please enter a unique tab name');
    if (enterName === null) {
      return {
        ...state,
      };
    }
    Dupe();
  }
  const renamedTab = tabs.find(tabItem => tabItem.key === event.selectedTab.key);
  renamedTab.tabName = enterName;
  const newTabs = [ ...tabs, ];
  return {
    selectedTab: renamedTab,
    tabs: newTabs,
  };
};

export default tab;
